import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/kit";

type ReportTermHintProps = {
  label: string;
  hint: string;
  className?: string;
};

/** Lao-first label with English/technical term explained on hover. */
export function ReportTermHint({
  label,
  hint,
  className,
}: ReportTermHintProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger
          type="button"
          className={
            className ??
            "cursor-help border-0 bg-transparent p-0 text-left text-inherit underline decoration-dotted underline-offset-2"
          }
        >
          {label}
        </TooltipTrigger>
        <TooltipContent className="max-w-64 text-balance">
          {hint}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
